// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"6fa41888","821":"fd412793","835":"d9ff4ddf"}[chunkId] + ".chunk.css";
};